const homeReviews = document.querySelector(".home-reviews");
const duration = 800;
let hasEnteredViewport = false;

// Set counter text to data-target value
const setCounterToTarget = (counter) => {
  counter.textContent = counter.getAttribute("data-target");
};

// Set all counters in a NodeList to their target values immediately
const setCountersToTarget = (counters) => {
  counters.forEach(setCounterToTarget);
};

// Animate counters and mark animation completion in sessionStorage
const animateCounters = (counters, storageKey) => {
  let completedCount = 0;
  const total = counters.length;

  counters.forEach(counter => {
    const target = parseInt(counter.getAttribute("data-target"), 10);
    if (isNaN(target)) return;

    const startTime = performance.now();

    const update = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      counter.textContent = Math.floor(progress * target);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = target;
        completedCount++;
        if (completedCount === total) {
          sessionStorage.setItem(storageKey, "true");
        }
      }
    };

    requestAnimationFrame(update);
  });
};

// Handle a single slide: if animated before, set values immediately, else animate
const animateCountersInSlide = (slide) => {
  if (!slide) return;

  const slideId = slide.getAttribute("data-slide-id");
  if (!slideId) return;

  const storageKey = `hasAnimated-${slideId}`;
  const counters = slide.querySelectorAll(".incrementCounter");

  if (sessionStorage.getItem(storageKey) === "true") {
    setCountersToTarget(counters);
  } else {
    animateCounters(counters, storageKey);
  }
};

// Early check: immediately set counters for slides already animated this session
const earlySessionStorageCheck = () => {
  const slides = document.querySelectorAll(".reviewcarousel .carousel-cell");
  slides.forEach(slide => {
    const slideId = slide.getAttribute("data-slide-id");
    if (!slideId) return;

    const storageKey = `hasAnimated-${slideId}`;
    if (sessionStorage.getItem(storageKey) === "true") {
      const counters = slide.querySelectorAll(".incrementCounter");
      setCountersToTarget(counters);
    }
  });
};

// Check and animate all selected slides when section in viewport or slide selected
const checkAndAnimateSelectedSlides = () => {
  if (!hasEnteredViewport) return;

  const selectedSlides = document.querySelectorAll(".reviewcarousel .carousel-cell.is-selected");
  selectedSlides.forEach(animateCountersInSlide);
};

// Intersection Observer triggers when .home-reviews enters viewport center
if (homeReviews) {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const rect = entry.boundingClientRect;
      const elementCenter = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;

      if (Math.abs(elementCenter - viewportCenter) < rect.height / 2) {
        hasEnteredViewport = true;
        checkAndAnimateSelectedSlides();
        obs.disconnect();
      }
    });
  }, { threshold: 0.5 });

  observer.observe(homeReviews);

  // Run early sessionStorage check as soon as possible (on load or immediately)
  if (document.readyState === "complete" || document.readyState === "interactive") {
    earlySessionStorageCheck();
  } else {
    window.addEventListener("DOMContentLoaded", earlySessionStorageCheck);
  }
}

// Mutation Observer watches for changes in slide selection
const reviewCells = document.querySelectorAll(".reviewcarousel .carousel-cell");

if (reviewCells.length > 0) {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(({ target, type }) => {
      if (type === "attributes" && target.classList.contains("is-selected")) {
        checkAndAnimateSelectedSlides();
      }
    });
  });

  reviewCells.forEach(cell => {
    mutationObserver.observe(cell, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
}
